/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { cssProps } from '@oracle/oraclejet-cssprops';
import { classNames } from '../utils/UNSAFE_classNames';
import { LineProps } from './Shapes.types';

export const Line = ({ lineWidth = 3, lineStyle = 'solid', color }: LineProps) => {
  const isNotSolid = lineStyle != 'solid';
  return (
    <line
      x1={0}
      y1={50}
      x2={100}
      y2={50}
      stroke={color}
      strokeWidth={lineWidth}
      class={classNames([lineStyles.base, isNotSolid ? lineStyles[lineStyle] : ''])}
    />
  );
};

const lineStyles = {
  base: cssProps`${{
    vectorEffect: 'non-scaling-stroke',
    shapeRendering: 'crispEdges'
  }}`,
  dotted: cssProps`${{
    strokeDasharray: '2'
  }}`,
  dashed: cssProps`${{
    strokeDasharray: '4 1 4'
  }}`
};
